<template>

    <div class="widget-ticker"
    :style="{
        background: config?.backgroundColor || '#000',
        color: config?.fontColor || '#fff',
        fontSize: (config?.fontSize || 20) + 'px',
        fontFamily: config?.fontFamily || 'Arial',
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    }"
    >
      <div
        class="ticker-track-horizontal"
        :style="{
          animationDuration: (config?.tickerSpeed || 100) + 's',
        }"
      >
        <div class="ticker-content">
          <template v-for="(text, index) in tickerTexts" :key="index">
            <span v-if="index > 0" class="ticker-separator-container">
              <span
                class="ticker-separator"
                :style="{
                  color: config?.seperatorColor || '#000000',
                  padding: `0 ${config?.separatorPadding || 10}px`,
                }"
                >{{ config?.separator || "|" }}</span
              >
            </span>
            <span class="ticker-text">{{ text }}</span>
          </template>
        </div>

        <div class="ticker-content" aria-hidden="true">
          <template v-for="(text, index) in tickerTexts" :key="'dup-' + index">
            <span v-if="index > 0" class="ticker-separator-container">
              <span
                class="ticker-separator"
                :style="{
                  color: config?.seperatorColor || '#000000',
                  padding: `0 ${config?.separatorPadding || 10}px`,
                }"
                >{{ config?.separator || "|" }}</span
              >
            </span>
            <span class="ticker-text">{{ text }}</span>
          </template>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
export default {
  name: "TickerWidget",
};
</script>
<script setup lang="ts">
import {computed, defineProps} from 'vue';
const props = defineProps({
    config: {
        type: Object,
        required: true,
    },
});

const tickerTexts = computed(() => {
  if (Array.isArray(props.config.texts) && props.config.texts.length > 0) {
    return props.config.texts.map((t: { text: string }) => t.text);
  }
  // For testing, use a long string if empty
  return [props.config.text || "This is a sample ticker text. Add more items for sliding effect."];
});



</script>

<style scoped>

/* Ticker styles */
.widget-ticker {
  position: relative !important;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex !important;
  align-items: center;
}

.ticker-track-horizontal {
  display: flex !important;
  white-space: nowrap;
  width: max-content;
  align-items: center;
  animation: ticker-horizontal 12s linear infinite !important;
  height: 100%;
  line-height: normal;
  will-change: transform;
}


.ticker-content {
  display: inline-flex !important;
  padding-right: 0.5rem;
  flex-wrap: nowrap;
  align-items: center;
  height: 100%;
  white-space: nowrap;
}

.ticker-separator-container,
.ticker-text {
  display: inline-flex !important;
  align-items: center;
  white-space: nowrap;
  height: 100%;
  line-height: normal;
}

.ticker-separator {
  display: inline-block !important;
  white-space: nowrap;
}

@keyframes ticker-horizontal {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

:fullscreen .ticker-track-horizontal {
  animation: ticker-horizontal 12s linear infinite !important;
  width: max-content !important;
}
</style>
